import { render, staticRenderFns } from "./ExamEnvDtect.vue?vue&type=template&id=5d8df77d&scoped=true&"
import script from "./ExamEnvDtect.vue?vue&type=script&lang=js&"
export * from "./ExamEnvDtect.vue?vue&type=script&lang=js&"
import style0 from "./ExamEnvDtect.vue?vue&type=style&index=0&id=5d8df77d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8df77d",
  null
  
)

export default component.exports